// extracted by mini-css-extract-plugin
export default {"linkBack":"shopping-cart-module--link-back--1Qseu","linkBackIcon":"shopping-cart-module--link-back-icon--3i_kz","cart":"shopping-cart-module--cart--1t_zf"};